<template>
  <form-template
    :data="data"
    :blocks="blocks"
    :snackbar="snackbar"
    title="Подзаголовок"
    @save="save"
  >
    <v-text-field
      v-model="override.content"
      counter
      label="Контент"
      :rules="[rules.required]"
    />
  </form-template>
</template>

<script>
import formMixin from "./formMixin";
import FormTemplate from "./Template";

export default {
  name: "FormH2",
  components: { FormTemplate },
  mixins: [formMixin],
  data() {
    return {
      override: {
        content: this.data.content
      }
    };
  }
};
</script>
